import { createContext, useContext } from 'react';

interface SearchContextType {
    query: string;
    setQuery: (query: string) => void;
    adults: number;
    setAdults: (n: number) => void;
    children: number;
    setChildren: (n: number) => void;
    rooms: number;
    setRooms: (n: number) => void;
}

export const SearchContext = createContext<SearchContextType | undefined>(
    undefined,
);

export function useSearchContext() {
    const context = useContext(SearchContext);
    if (!context) {
        throw new Error('useSearchContext must be used within SearchProvider');
    }
    return context;
}
